<template>
	<div style="background-color: #fff;padding: 20px;" class="container-top">
		<!-- 右上角 返回按钮 -->
		<div class="header">
			<a-button @click="goBack" class="back-btn">
				<a-icon type="left" /> 返回
			</a-button>
		</div>
		<div class="titleCz">代工咨询需求</div>
		<a-descriptions :column="1" bordered style="flex: 1;">
			<a-descriptions-item label="需求单号">
				{{detailModel.inquiryNo}}
			</a-descriptions-item>
			<a-descriptions-item label="需求提交时间">
				{{detailModel.createTime }}
			</a-descriptions-item>

			<a-descriptions-item label="用户称呼">
				{{detailModel.userName}}
			</a-descriptions-item>
			<a-descriptions-item label="手机号码">
				{{detailModel.userPhone}}
			</a-descriptions-item>

			<a-descriptions-item label="公司名称">
				{{detailModel.companyName}}
			</a-descriptions-item>
			<a-descriptions-item label="目标宠物类别（单选）">
				<a-radio-group v-model="detailModel.petType" disabled @change="onChange">
					<a-radio value="DOG">
						犬用
					</a-radio>
					<a-radio value="CAT">
						猫用
					</a-radio>
					<a-radio value="OTHER">
						其他
					</a-radio>
				</a-radio-group>
				<!-- 选中OTHER才展示输入框，同样disabled纯展示 -->
				<a-input v-if="detailModel.petType === 'OTHER'" v-model="detailModel.petTypeOther" disabled
					placeholder="请注明" style="width: 160px; margin-left: 12px;" />
			</a-descriptions-item>
			<a-descriptions-item label="食品类型（多选）">

				<!-- "foodTypes": "", //["HEALTH", "OTHER"] -- 保健品 + 其他 -->
				<!-- "foodTypeOther": "", //其他食品类型说明 -->
				<!-- 多选框整体禁用，纯展示 -->
				<div style="display:flex;flex-direction:column;gap:8px;">
					<a-checkbox-group v-model="detailModel.foodTypes" disabled>
						<a-checkbox value="MAIN">主粮（干粮/湿粮）</a-checkbox>
						<a-checkbox value="SNACK">零食（磨牙棒/肉干/冻干等）</a-checkbox>
						<a-checkbox value="HEALTH">保健品</a-checkbox>
						<a-checkbox value="OTHER">其他（请注明）</a-checkbox>
					</a-checkbox-group>
					<a-input v-if="detailModel.foodTypes && detailModel.foodTypes.includes('OTHER')" v-model="detailModel.foodTypeOther" disabled
						placeholder="请注明其他食品类型" style="width: 220px;" />
				</div>
			</a-descriptions-item>
			<a-descriptions-item label="产品配方（单选）">
				<a-radio-group v-model="detailModel.formulaType" disabled @change="onChange">
					<a-radio value="OWN">
						自有配方
					</a-radio>
					<a-radio value="FACTORY">
						工厂现有配方
					</a-radio>
					<a-radio value="RD">
						委托工厂研发配方
					</a-radio>
				</a-radio-group>
			</a-descriptions-item>
			<a-descriptions-item label="其他需求说明">
				{{detailModel.otherRequirements}}
			</a-descriptions-item>
			<a-descriptions-item label="处理状态">
				<a-select style="width: 200px" v-model="detailModel.status" class="mr12" placeholder="请选择处理状态"
					show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of tags" :key="index" :value="item.tagId">
						{{ item.tagName }}
					</a-select-option>
				</a-select>
			</a-descriptions-item>
			<a-descriptions-item label="备注">
				<a-textarea placeholder="输入备注内容（后台查看不同步前端）" v-model="detailModel.remark" />
			</a-descriptions-item>
		</a-descriptions>
		<div style="height: 40px;"></div>
		<a-button @click="sureEdit" type="primary">保存</a-button>
		<div style="height: 40px;"></div>
		<div class="titleCz">操作日志</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
		</a-table>

	</div>
</template>

<script>
	import moment from 'moment'
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getInquireDetailApi,
		operationLogApi,
		editInquireApi
	} from "../../api/index";

	export default {
		name: "ADDETAIL",
		data() {
			return {
				"factoryThumbnail": "/uploads/thumbnail/factory1.jpg",
				bannerUrl: "",
				form: this.$form.createForm(this),
				detailModel: {

				},
				tags: [{
						tagId: 'PENDING',
						tagName: "待处理",
					},
					{
						tagId: 'PROCESSING',
						tagName: "处理中",
					},
					{
						tagId: 'RESOLVED',
						tagName: "已处理",
					}
				],
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: "操作员",
						dataIndex: "operator",
						key: "operator",
					},
					{
						title: "操作",
						dataIndex: "operation",
						key: "operation",
					},
					{
						title: "时间",
						dataIndex: "operationTime",
						key: "operationTime",
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				inquiryId: null,

				innerType: undefined,
				radioStyle: {
					display: 'block',
					height: '30px',
					lineHeight: '30px',
				},

			};
		},
		methods: {
			onChange(e) {
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			goBack() {this.$router.back();},
			innerTypechangeTabTop(e) {

			},
			sureEdit() {
				let params = {
					"inquiryId": this.inquiryId,
					"status": this.detailModel.status,
					"remark": this.detailModel.remark,
				}
				editInquireApi(params)
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								'保存成功'
								// this.editModel.inquiryId ? "编辑成功" : "新增成功"
							);
						} else {
						}
					})
					.catch((error) => {
					})
					.finally(() => {})
			},
			disabledDate(current) {
				return current && current < moment().subtract(1, 'days').endOf('day')
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			handleUpdataFile(e) {
				if (e.target.files.length) {
					if (e.target.files.length) {
						const file = e.target.files[0];
						if (file) {
							ossUpload(file, '', 'image/').then((res) => {

								this.form.setFieldsValue({
									bannerUrl: res.url
								});
								this.detailModel.bannerUrl = res.url;
							}).catch(err => {
								this.$message.error('图片上传失败')
							});
						}
					}
				}
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},

			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				operationLogApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						userId: this.inquiryId,
						targetType: 'INQUIRY',
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];

							this.pageInfo.total = res.resultData.totalNum || 0;
							this.orderStaticsVO = res.resultData.userStatics
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			// here123
			getDetails() {
				this.$nextTick(() => {
					getInquireDetailApi({
						inquiryId: this.inquiryId,
					}).then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.detailModel = {
								"inquiryId": result.inquiryId,
								"inquiryNo": result.inquiryNo, //需求单号
								"userName": result.userName, //用户称呼
								"userPhone": result.userPhone, //手机号码
								"companyName": result.companyName, //公司名称
								"petType": result.petType, //目标宠物类别：DOG-犬用 CAT-猫用 OTHER-其他
								"petTypeOther": result.petTypeOther, //其他宠物类别（当petType=OTHER时）
								"foodTypes": result.foodTypes, //["HEALTH", "OTHER"] -- 保健品 + 其他
								"foodTypeOther": result.foodTypeOther, //其他食品类型说明
								"formulaType": result
									.formulaType, //产品配方：OWN-自有配方 FACTORY-工厂现有配方 RD-委托工厂研发配方
								"otherRequirements": result.otherRequirements, // "其他需求说明", //其他需求说明
								"remark": result.remark, //备注（后台查看，不同步前端）
								"status": result.status, //处理状态：PENDING-待处理 PROCESSING-处理中 RESOLVED-已处理
								"userId": result.userId,
								"createTime": result.createTime, //需求提交时间
								"replyContent": result.replyContent
							};
						} else {
							this.$message.warn(res.errorMessage);
							this.detailModel = {
								"inquiryId": "",
								"inquiryNo": "", //需求单号
								"userName": "", //用户称呼
								"userPhone": "", //手机号码
								"companyName": "", //公司名称
								"petType": "", //目标宠物类别：DOG-犬用 CAT-猫用 OTHER-其他
								"petTypeOther": null, //其他宠物类别（当petType=OTHER时）
								"foodTypes": null, //["HEALTH", "OTHER"] -- 保健品 + 其他
								"foodTypeOther": null, //其他食品类型说明
								"formulaType": null, //产品配方：OWN-自有配方 FACTORY-工厂现有配方 RD-委托工厂研发配方
								"otherRequirements": null, // "其他需求说明", //其他需求说明
								"remark": "", //备注（后台查看，不同步前端）
								"status": "PENDING", //处理状态：PENDING-待处理 PROCESSING-处理中 RESOLVED-已处理
								"userId": null,
								"createTime": "", //需求提交时间
								"replyContent": null
							};
						}
					});

				})


			},
		},
		mounted() {
			const inquiryId = this.$route.params.id;
			this.inquiryId = inquiryId
			if (this.inquiryId) {
				this.getDetails(this.inquiryId)
			} else {
				this.form.setFieldsValue({
					bannerImageType: 'IMAGE'
				})
			}
			this.getData(1)
		},
		activated() {},
	};
</script>

<style lang="less" scoped>
	.titleCz {
		font-size: 18px;
		font-size: 18px;
		color: #333333;
		line-height: 18px;
		margin-bottom: 30px;
	}

	.container-top {
		padding: 20px;
		background-color: #fff;
		width: 1000px;
		margin-left: 80px;

		/* 右上角按钮 */
		.header {
			text-align: right;
			margin-bottom: 16px;
		}

		.title {
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			// margin-bottom: 30px;
		}

		.titleCz {
			font-size: 18px;
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			margin-bottom: 30px;
		}

		.ant-form-item {
			// margin-bottom: 0px !important;
		}

		/* disabled 组件颜色与正常文字保持一致 */
		::v-deep .ant-radio-wrapper-disabled .ant-radio + span {
			color: rgba(0, 0, 0, 0.65) !important;
		}
		::v-deep .ant-radio-wrapper-disabled .ant-radio-disabled .ant-radio-inner {
			background-color: #fff !important;
		}
		::v-deep .ant-radio-wrapper-disabled .ant-radio-checked .ant-radio-inner {
			border-color:  rgba(0, 0, 0, 0.65)  !important;
		}
		::v-deep .ant-radio-wrapper-disabled .ant-radio-checked .ant-radio-inner::after {
			background-color: rgba(0, 0, 0, 0.65)  !important;
		}
		::v-deep .ant-checkbox-disabled + span {
			color:  rgba(0, 0, 0, 0.65)  !important;
		}
		::v-deep .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
			border-color:  rgba(0, 0, 0, 0.65) !important;
		}
		::v-deep .ant-checkbox-disabled .ant-checkbox-inner {
			background-color: #fff !important;
		}
		::v-deep .ant-input[disabled] {
			color: rgba(0, 0, 0, 0.65)  !important;
			background-color: #fff !important;
			cursor: default;
		}
	}
</style>
